import React, { useMemo } from 'react';
import { Helmet } from 'react-helmet-async';
import { useApprovedReviews } from '../hooks/useApprovedReviews';
import { buildReviewSchema } from '../utils/reviewSchema';

const ReviewSchema: React.FC = () => {
  const { reviews } = useApprovedReviews();

  const schema = useMemo(() => buildReviewSchema(reviews), [reviews]);

  if (!schema) return null;

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(schema)}</script>
    </Helmet>
  );
};

export default ReviewSchema;
